import en from "./en.translation.json";
import es from "./es.translation.json";
import _ from "lodash";
import workerSelectTemplate from "./worker_select.html";

export class WorkerSelectController {
    /* @ngInject */
    constructor($scope, GrowerMembershipService, AccountService, $q) {
        this.$scope = $scope;
        this.GrowerMembershipService = GrowerMembershipService;
        this.AccountService = AccountService;
        this.$q = $q;
        this.selectedUsers = new Set();
        this.showSpinner = {};
    }

    $onInit() {
        let ctrl = this;

        ctrl.$scope.$watchCollection(
            () => Array.from(ctrl.selectedUsers),
            (newValue, oldValue) => {
                ctrl.refreshWorkers().finally(() => {
                    ctrl.update();
                    ctrl.resetSearch();
                });
            },
        );

        const initialSelection = ctrl.selectedWorker
            ? [ctrl.selectedWorker]
            : ctrl.selectedWorkers || [];
        ctrl.selectedUsers = new Set(initialSelection);

        // Paging state for results list (default chunk size 100)
        ctrl.resultsPageSize = 100;
        ctrl.currentResultsLimit = ctrl.resultsPageSize;
    }

    search() {
        let ctrl = this;
        if (!ctrl.searchQuery) {
            ctrl.addDefaultSearchResults();
            return;
        }

        ctrl.GrowerMembershipService.search(
            ctrl.searchQuery,
            "grower_organization_sid:" + ctrl.grower.sid,
        ).then(({ hits }) => {
            ctrl.results = [];
            for (let hit of hits) {
                let worker = _.find(ctrl.eligibleWorkers, [
                    "growerMembership.sid",
                    hit.objectID,
                ]);
                if (worker) {
                    ctrl.results.push(worker);
                }
            }
        });
    }

    resetSearch() {
        let ctrl = this;
        ctrl.searchQuery = "";
        // Reset paging when clearing search
        ctrl.currentResultsLimit = ctrl.resultsPageSize;
        ctrl.addDefaultSearchResults();
        ctrl.showSpinner = {};
    }

    addDefaultSearchResults() {
        let ctrl = this;
        ctrl.eligibleWorkers = _.filter(ctrl.workers, (worker) => {
            return !ctrl.selectedUsers.has(worker.user.sid);
        });
        // Order once; apply current limit (initially 100)
        const ordered = _.orderBy(
            ctrl.eligibleWorkers,
            ["growerMembership.first_name", "growerMembership.last_name"],
            ["asc"],
        );
        ctrl.results = _.take(ordered, ctrl.currentResultsLimit);
    }

    refreshWorkers() {
        let ctrl = this;

        if (ctrl.selectedUsers.size === 0) {
            ctrl.selectedWorkersDisplay = [];
            return ctrl.$q.resolve();
        }

        const userSids = Array.from(ctrl.selectedUsers).join(",");

        let growerMemberships = ctrl.GrowerMembershipService.list({
            user__sid__in: userSids,
            grower_organization__sid: ctrl.grower.sid,
        });

        let users = ctrl.AccountService.list({
            sid__in: userSids,
        });

        return ctrl.$q.all([growerMemberships, users]).then(function ([
            memberships,
            users,
        ]) {
            let selectedWorkersDisplay = memberships.map((growerMembership) => {
                const user = users.find(
                    (user) => user.sid === growerMembership.user,
                );
                return {
                    growerMembership,
                    user,
                };
            });
            ctrl.selectedWorkersDisplay = _.orderBy(
                selectedWorkersDisplay,
                ["growerMembership.first_name", "growerMembership.last_name"],
                ["asc"],
            );
        });
    }

    removeWorker(userSid) {
        let ctrl = this;
        ctrl.selectedUsers.delete(userSid);
    }

    selectWorker(worker) {
        let ctrl = this;
        if (!ctrl.single || ctrl.selectedUsers.size === 0) {
            ctrl.showSpinner[worker.user.sid] = true;
            ctrl.selectedUsers.add(worker.user.sid);
        }
    }

    update() {
        let ctrl = this;
        let value = [...ctrl.selectedUsers];
        if (ctrl.single) {
            value = value[0];
        }
        if (value) {
            ctrl.onUpdate({ value });
        }
    }

    loadMore() {
        let ctrl = this;
        // Increase limit by page size and recompute results (only applies when not actively searching)
        ctrl.currentResultsLimit += ctrl.resultsPageSize;
        // Rebuild default results if no active search query
        if (!ctrl.searchQuery) {
            ctrl.addDefaultSearchResults();
        }
    }
}

export default {
    bindings: {
        selectedWorker: "<",
        selectedWorkers: "<",
        onUpdate: "&",
        grower: "<",
        single: "<",
        workers: "<",
    },
    controller: WorkerSelectController,
    template: workerSelectTemplate,
    name: "workerSelect",
    translations: { en, es },
};
